import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardList, MapPin, ChevronRight, Hammer } from 'lucide-react';
import api from '@/lib/api';
import { formatDate } from '@/lib/format';
import { StageBadge } from '@/components/StatusBadge';
import { ListSkeleton } from '@/components/Skeletons';
import { EmptyState } from '@/components/EmptyState';
import { useAuth } from '@/context/AuthContext';

export default function TugasSaya() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await api.get('/projects'); setItems(r.data); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const aktif = items.filter((p) => p.stage !== 'Selesai');
  const selesai = items.filter((p) => p.stage === 'Selesai');

  return (
    <div className="space-y-4">
      <div className="rounded-2xl border bg-card p-5" style={{ backgroundImage: 'radial-gradient(700px 320px at 0% 0%, rgba(20,184,166,0.12), transparent 55%)' }}>
        <div className="flex items-center gap-2 text-sm text-muted-foreground"><Hammer className="h-4 w-4" /> Halo, {user?.nama}</div>
        <h1 className="font-display text-xl font-bold">Tugas Saya</h1>
        <p className="mt-1 text-sm text-muted-foreground">{aktif.length} pekerjaan aktif ditugaskan ke Anda.</p>
      </div>

      {loading ? <ListSkeleton /> : items.length === 0 ? (
        <EmptyState icon={ClipboardList} title="Belum ada tugas" description="Belum ada proyek yang ditugaskan ke Anda. Hubungi admin." />
      ) : (
        <div className="space-y-4">
          <div>
            <h2 className="mb-2 font-display text-sm font-semibold">Aktif</h2>
            <div className="space-y-2.5">
              {aktif.map((p) => (
                <button key={p.id} data-testid="tugas-card" onClick={() => navigate(`/proyek/${p.id}`)} className="flex w-full items-center gap-3 rounded-xl border bg-card p-4 text-left transition-shadow hover:shadow-[var(--shadow-md)]">
                  <div className="min-w-0 flex-1">
                    <div className="truncate font-semibold">{p.nama_proyek}</div>
                    <div className="truncate text-xs text-muted-foreground">{p.customer_name}</div>
                    <div className="mt-1.5 flex items-center gap-2"><StageBadge stage={p.stage} />{p.target_selesai && <span className="text-[11px] text-muted-foreground">Target {formatDate(p.target_selesai)}</span>}</div>
                  </div>
                  <ChevronRight className="h-5 w-5 shrink-0 text-muted-foreground" />
                </button>
              ))}
              {aktif.length === 0 && <p className="py-3 text-center text-sm text-muted-foreground">Tidak ada tugas aktif.</p>}
            </div>
          </div>
          {selesai.length > 0 && (
            <div>
              <h2 className="mb-2 font-display text-sm font-semibold">Selesai</h2>
              <div className="space-y-2.5">
                {selesai.map((p) => (
                  <button key={p.id} onClick={() => navigate(`/proyek/${p.id}`)} className="flex w-full items-center gap-3 rounded-xl border bg-card p-4 text-left opacity-80">
                    <div className="min-w-0 flex-1"><div className="truncate font-semibold">{p.nama_proyek}</div><div className="truncate text-xs text-muted-foreground">{p.customer_name}</div></div>
                    <StageBadge stage={p.stage} />
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
